import React, {FocusEventHandler, useEffect, useState} from "react";
import "./FieldTime.scss"
import {HourType, MinuteType, Time} from "../../utils";

export interface FieldTimeInputProps {
    id?: string
    required?: boolean
    label?: string
    value?: Time
    // valueHour?: string
    // valueMinutes?: string
    invalid?: boolean
    help?: string
    emptyDisplay?: string
    disabled?: boolean
    onChange?: (value: Time) => void
    onChangeHours?: (value: string) => void
    onChangeMinutes?: (value: string) => void
    onBlur?: FocusEventHandler<any> | undefined
}

const hourOptions: Array<{ value: HourType; label: string }> = Array.from(
    {length: 24},
    (_, val) => ({
        value: val as HourType,
        label: val.toString().padStart(2, '0')
    })
);

const minuteOptions: Array<{ value: MinuteType; label: string }> = Array.from(
    {length: 60},
    (_, val) => ({
        value: val as MinuteType,
        label: val.toString().padStart(2, '0')
    })
);


const FieldTime = function FieldTime({
                                         value,
                                         id,
                                         required,
                                         label,
                                         invalid,
                                         help,
                                         disabled,
                                         onChange,
                                         onBlur
                                     }: FieldTimeInputProps) {
    const inputId = id ? `${id}-input` : undefined

    const [hours, setHours] = useState<HourType | undefined>(value?.hours)
    const [minutes, setMinutes] = useState<MinuteType | undefined>(value?.minutes)
    useEffect(() => {
        setHours(value?.hours)
        setMinutes(value?.minutes)
    }, [value])

    return <>
        <div className={`field cmp-field-time ${required ? 'required' : ''}`}>
            {label && <label className={`label`} htmlFor={inputId}>{label}</label>}

            <div className={'field has-addons'}>
                <div className="control control-hours">
                    <div className={`select`}>
                        <select
                            id={inputId}
                            className={`select ${invalid ? 'is-danger' : ''}`}
                            disabled={disabled}
                            value={hours}
                            onBlur={onBlur}
                            onChange={e => {
                                const val = parseInt(e.target.value, 10)
                                if (!isNaN(val)) {
                                    setHours(val as HourType)

                                    if (onChange && val !== undefined && minutes !== undefined) {
                                        onChange({
                                            hours: val as HourType,
                                            minutes
                                        })
                                    }

                                }
                            }}
                        >
                            {!hours && <option key={'-'} value={'-'}>-</option>}
                            {hourOptions.map(e => <option key={e.value} value={e.value}>{e.label}</option>)}
                        </select>
                    </div>
                </div>

                <div className="control">
                    <span className="button is-static time-field-separator">
                        :
                    </span>
                </div>

                <div className="control control-minutes">
                    <div className={`select`}>
                        <select
                            className={`select ${invalid ? 'is-danger' : ''}`}
                            disabled={disabled}
                            value={minutes}
                            onBlur={onBlur}
                            onChange={e => {
                                const val = parseInt(e.target.value, 10)
                                if (!isNaN(val)) {
                                    setMinutes(val as MinuteType)

                                    if (onChange && hours !== undefined && val !== undefined) {
                                        onChange({
                                            hours,
                                            minutes: val as MinuteType
                                        })
                                    }
                                }
                            }}
                        >
                            {!minutes && <option key={'-'} value={'-'}>-</option>}
                            {minuteOptions.map(e => <option key={e.value} value={e.value}>{e.label}</option>)}
                        </select>
                    </div>
                </div>
            </div>

        </div>
        <p className={`help ${invalid ? 'is-danger' : ''}`}>{help}</p>
    </>
}


export {FieldTime}
